<label class="form-label">
  {{ props["required"] ? to.label + " *" : to.label }}
</label>

<div class="format-container" style="margin-bottom: 15px;">
<p-calendar
  [id]="id"
  (onSelect)="onSelect()"
  (change)="onSelect()"
  [view]="calendarView"
  appendTo="body"
  dataType="string"
  class="date-form-control"
  [dateFormat]="dateFormat"
  [formControl]="formControl"
  formlyAttributes
  [readonlyInput]="isReadOnlyInput"
  (onFocus)="onFocus()"
  (onBlur)="onBlur()"
  [inputStyle]="{ height: '37px' }"
  [ngClass]="{
    'disabled-calendar': formControl.disabled,
    'calendar-invalid': showError
  }"
  [placeholder]="placeholder"
>
</p-calendar>

  <!-- Selección de formato si aplica -->
  <ng-container *ngIf="showFormat; else fixedFormat">
    <select
      [value]="dateFormat"
      (change)="setDateFormat($event.target.value)"
      class="form-select"
      style="width: 160px; height: 37px; margin-left: 7px"
      [disabled]="formControl.disabled"
    >
      <option value="dd/mm/yy">dd/mm/yyyy</option>
      <option value="mm/yy">mm/yyyy</option>
    </select>
  </ng-container>

  <ng-template #fixedFormat>
    <select
      class="form-select"
      style="width: 160px; height: 37px; margin-left: 7px"
      disabled
    >
      <option value="dd/mm/yy">dd/mm/yyyy</option>
    </select>
  </ng-template>
</div>

<!-- Mensajes de error -->
<div *ngIf="showError" class="error-message"
     style="margin-bottom: 15px; margin-top: -15px">
  <formly-validation-message [field]="field"></formly-validation-message>
</div>